import { type MobileSteps } from '@store/mobile-reducer.ts'
import { useMobileContext } from '@hooks/use-mobile-context.ts'

function useMobileUtils() {
	const { dispatch } = useMobileContext()

	const moveTo = (to: MobileSteps) => {
		dispatch({
			type: 'MOVE_STEP',
			payload: to,
		})
	}

	return {
		moveTo,
	}
}

export { useMobileUtils }
